export const Template1 = 'template1'
export const Template2 = 'template2'
export const Template3 = 'template3'
export const Template4 = 'template4'